import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import ReceivableServiceLink, { ReceivableServiceCell } from '../ReceivableServiceLink';
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import MainHelper, {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
import {connect} from "react-redux";
export class CariTransactionsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    handleDelete = async (receiveId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/receivable/delete/'+receiveId,'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Alacak başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleReceivableDetail = (receiveId) => {
        this.props.history.push(`/receivable-detail/${receiveId}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions,customer_id} = this.props;
        const userHasViewReceivablePermission = userPermissions.includes('view receivable');
        const userHasDeleteReceivablePermission = userPermissions.includes('delete receivable');
        const userHasViewServicePermission = userPermissions.includes('view service');
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Servis No',
                selector:row => Number(row.operation?.id || row.operation_id || 0),
                cell:row => <ReceivableServiceCell row={row} canView={userHasViewServicePermission} />,
                sortable:true
            },

            {
                name:'Tip',
                selector:row => row.b_a === "alacak" ? "Alacak" : "Borç",
                sortable:true
            },
            {
                name:'Son Ödeme Tarihi',
                selector:row => MainHelper.dateFormat(row.due_date).split(' 0')[0]
            },
            {
                name:'Tutar',
                selector:row => row.amount
            },
            {
                name:'Kalan Tutar',
                selector:row => row.remaining_amount === null || row.remaining_amount === undefined
                    ? row.amount
                    : row.remaining_amount
            },
            {
                name:'Durum',
                selector:row => <span className={`badge badge-${row.status === "Ödendi" ? "success" : "danger"}`}>{row.status}</span>
            },
            {
                name: 'İşlem',
                button: true,
                width: '100px',
                cell: row => <div className="sz-record-actions" data-row-action>
                    <ReceivableServiceLink row={row} canView={userHasViewServicePermission} />
                    {userHasDeleteReceivablePermission && <button type="button" className="sz-record-action delete" title="Cari kaydı sil" aria-label="Cari kaydı sil" onClick={() => this.handleDelete(row.id)}><i className="icon-trash" aria-hidden="true" /></button>}
                </div>
            }

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/receivable/cari/all/"+customer_id}
                columns={columns}
                onRowClicked={userHasViewReceivablePermission ? row => this.handleReceivableDetail(row.id) : undefined}
                searchPlaceholder="Servis no, plaka veya cari hareket ara…"
                progressPending={pending}>
            </DataTable>
        )
    }

}

const mapStateToProps = ({ioTReducer}) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
    customer_id:ioTReducer.customer_id
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(CariTransactionsTable)));
